import { Datagrid, DateField, List, NumberField, TextField } from 'react-admin';

export const Penilaian_siseraList = () => (
    <List sort={{ field: 'created_at', order: 'DESC' }}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="wa_pengunjung" />
            <NumberField source="p1" />
            <NumberField source="p2" />
            <NumberField source="p3" />
            <NumberField source="p4" />
            <NumberField source="p5" />
            <NumberField source="p6" />
            <NumberField source="p7" />
            <NumberField source="p8" />
            <NumberField source="p9" />
            <NumberField source="p10" />
            <TextField source="saran" />
            <DateField source="created_at" />
        </Datagrid>
    </List>
);